
    import _ from 'underscore';
    import {
        computed,
        defineComponent,
        onMounted,
        onUnmounted,
        ref,
        unref,
        watch,
        nextTick,
    } from 'vue';
    import useDatesTabs from '@ve/components/hotel/datesTabs/common/useDatesTabs';
    import { DatesAndPricesItem } from '@ve/components/hotel/datesTabs/common/types/IMapForDatesTabsStore';
    import DatesTabsItemDesktop from './DatesTabsItem.vue';
    import BestPriceGoTo from './BestPriceGoTo.vue';

    export default defineComponent({
        name: 'DatesTabsDesktop',
        components: {
            DatesTabsItemDesktop,
            BestPriceGoTo,
        },
        setup() {
            const {
                productsAvailable,
                datesAndPrices,
                selectedDate,
                datesTabsContent,
                containerWidth,
                itemWidth,
                bestPriceDate,
                selectTabDate,
                searchDates,
                manuallySelectedDate,
                loadingState,
            } = useDatesTabs();
            const pageNumber = ref(0);

            const itemsVisibleCount = computed(() => {
                const containerWidthData = unref(containerWidth);
                const itemWidthData = unref(itemWidth);
                if (!(containerWidthData && itemWidthData)) return null;
                return Math.round(containerWidthData / itemWidthData);
            });

            const maxPages = computed(() => {
                const itemsNumber = Object.values(unref(datesAndPrices)).length;
                const itemsVisibleCountData = unref(itemsVisibleCount);
                return itemsVisibleCountData && itemsNumber - itemsVisibleCountData > 0 ? itemsNumber - itemsVisibleCountData : 0;
            });

            const nextAvailable = computed(() => unref(pageNumber) < unref(maxPages));

            const prevAvailable = computed(() => unref(pageNumber) > 0);

            const offset = computed(() => {
                const itemWidthData = unref(itemWidth);
                return itemWidthData ? unref(pageNumber) * itemWidthData : null;
            });

            const correctPageNumber = (selectedDateValue: string) => {
                const manuallySelectedDateValue = unref(manuallySelectedDate);
                const datesAndPricesData = (unref(datesAndPrices) ? Object.values(unref(datesAndPrices)) : []) as DatesAndPricesItem[];
                const selectedDateIndex = _.findIndex(datesAndPricesData, (element) => element.startDate === selectedDateValue);
                const currentPageNumber = unref(pageNumber);
                const itemsVisibleCountData = unref(itemsVisibleCount);

                if (itemsVisibleCountData) {
                    if (manuallySelectedDateValue) {
                        if (selectedDateIndex < currentPageNumber) {
                            pageNumber.value = selectedDateIndex;
                        } else if (selectedDateIndex > currentPageNumber + itemsVisibleCountData - 1) {
                            pageNumber.value = selectedDateIndex - itemsVisibleCountData + 1;
                        }
                    } else {
                        //if date selected automatically - selected date should be middle
                        const centerOffset = Math.floor(itemsVisibleCountData / 2);

                        if (selectedDateIndex - centerOffset > unref(maxPages)) {
                            pageNumber.value = unref(maxPages);
                        } else if (selectedDateIndex - centerOffset < 0) {
                            pageNumber.value = 0;
                        } else {
                            pageNumber.value = selectedDateIndex - centerOffset;
                        }
                    }
                }
            };

            watch(selectedDate, (selectedDateValue) => nextTick(() => correctPageNumber(selectedDateValue)));

            const _resizeHandler = () => correctPageNumber(unref(selectedDate));
            onMounted(() => {
                window.addEventListener('resize', _resizeHandler);
            });
            onUnmounted(() => {
                window.removeEventListener('resize', _resizeHandler);
            });

            const navigate = (direction: 'prev' | 'next') => {
                if (direction === 'next' && unref(pageNumber) < unref(maxPages)) {
                    pageNumber.value++;
                } else if (unref(pageNumber) > 0) {
                    pageNumber.value--;
                }
            };

            watch(containerWidth, () => {
                if (unref(pageNumber) > unref(maxPages)) {
                    pageNumber.value = unref(maxPages);
                }
            });

            const goToBestDate = ({ pageNumber: pageNumberValue }: {
                pageNumber: number;
            }) => {
                pageNumber.value = pageNumberValue;
            };

            return {
                productsAvailable,
                datesAndPrices,
                selectedDate,
                datesTabsContent,
                bestPriceDate,
                nextAvailable,
                prevAvailable,
                offset,
                navigate,
                selectTabDate,
                goToBestDate,
                searchDates,
                pageNumber,
                loadingState,
                itemsVisibleCount,
                maxPages,

                //for tests debug
                containerWidth,
                itemWidth,
                correctPageNumber,
            };
        },
    });
